import type { InvitationHistoryRow } from './invitationHistoryRows'

/**
 * Excel treats a cell opening with one of these as a formula even inside a quoted CSV field, so a
 * recipient name starting with `=` would be evaluated on open. A leading apostrophe is Excel's own
 * escape for "this is text" and is not shown in the cell.
 */
const FORMULA_LEAD = /^[=+\-@\t\r]/

const escape = (value: string): string => {
  let text = value

  if (FORMULA_LEAD.test(text)) {
    text = `'${text}`
  }

  return `"${text.replace(/"/g, '""')}"`
}

/**
 * The visible columns of the history grid, in order, one line per channel row so the file matches what
 * the grid shows. The language label is passed in rather than resolved here so this stays free of any
 * runtime dependency and can be tested on its own.
 */
export const toCsv = (
  rows: InvitationHistoryRow[],
  headers: string[],
  formatLanguage: (languageId: number) => string,
): string => {
  const lines = rows.map((row) =>
    [
      row.communicationType,
      `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim(),
      row.recipient ?? '',
      formatLanguage(row.languageId),
      row.sentAt,
      row.sentByUserFullname ?? '',
      row.deliveryStatus ?? '',
    ]
      .map(escape)
      .join(','),
  )

  return [headers.map(escape).join(','), ...lines].join('\n')
}
